import ExportService from "@/services/exportService";

export default {
  methods: {
    /**
     * Exporta contenido HTML a Excel
     * @param {string} containerId - ID del contenedor HTML
     * @param {string} fileName - Nombre del archivo (sin extensión)
     * @param {Object} options - Opciones adicionales
     */
    async exportHtmlToExcel(containerId, fileName, options = {}) {
      return await ExportService.exportWithLoading(
        async () =>
          await ExportService.exportHtmlToExcel(containerId, fileName, options),
        "Generando Excel...",
        this
      );
    },

    /**
     * Exporta datos estructurados a Excel
     * @param {Array} data - Array de arrays con los datos
     * @param {string} fileName - Nombre del archivo (sin extensión)
     * @param {string} sheetName - Nombre de la hoja
     */
    async exportDataToExcel(data, fileName, sheetName = "Datos") {
      return await ExportService.exportWithLoading(
        async () =>
          await ExportService.exportDataToExcel(data, fileName, sheetName),
        "Generando Excel...",
        this
      );
    },

    /**
     * Exporta datos de un modelo dinámico a Excel
     * @param {Array} fields - Campos del modelo
     * @param {Object} item - Datos del item
     * @param {string} fileName - Nombre del archivo (sin extensión)
     * @param {Array} lists - Listas disponibles (opcional)
     * @param {Array} models - Modelos disponibles (opcional)
     */
    async exportModelToExcel(fields, item, fileName, lists = [], models = []) {
      const data = this.prepareModelData(fields, item, lists, models);
      return await this.exportDataToExcel(data, fileName, "Datos");
    },

    /**
     * Prepara datos de un modelo para exportación
     * @param {Array} fields - Campos del modelo
     * @param {Object} item - Datos del item
     * @param {Array} lists - Listas disponibles
     * @param {Array} models - Modelos disponibles
     * @returns {Array} Datos preparados
     */
    prepareModelData(fields, item, lists = [], models = []) {
      const data = [];
      const headers = fields.map((field) => field.label || field.key);
      data.push(headers);

      const row = fields.map((field) => {
        const value = item[field.key];
        if (field.type === "date" && value) {
          return new Date(value).toLocaleDateString("es-ES");
        }
        if (field.type === "list") {
          if (field.isArray && Array.isArray(value)) {
            return value
              .map((v) => this.getListOptionLabel(field, v, lists))
              .join(", ");
          }
          return this.getListOptionLabel(field, value, lists);
        }
        if (field.type === "reference") {
          const refModel = models.find((m) => m.modelName === field.ref);
          if (refModel && value) {
            if (typeof value === "object" && value._id) {
              return value.name || value.label || value._id;
            }
            return value;
          }
        }
        if (field.type === "group") {
          return value ? JSON.stringify(value) : "";
        }
        return value || "";
      });
      data.push(row);

      return data;
    },

    /**
     * Obtiene la etiqueta de una opción de lista
     * @param {Object} field - Campo de tipo lista
     * @param {*} value - Valor del campo
     * @param {Array} lists - Listas disponibles
     * @returns {string} Etiqueta de la opción
     */
    getListOptionLabel(field, value, lists = []) {
      if (!value) return "";

      const id = typeof value === "object" && value._id ? value._id : value;
      const list = lists?.find((l) => l.type === field.listType);
      if (!list || !list.values) return String(id);

      const option = list.values.find((opt) => opt._id === id);
      return option ? option.label : String(id);
    },
  },
};
